import type { FC } from "react";
import { Box, Typography } from "@mui/material";
import type { DashboardCapacityMetric } from "../types";

export interface DashboardCapacityRowProps {
  metric: DashboardCapacityMetric;
}

export const DashboardCapacityRow: FC<DashboardCapacityRowProps> = ({ metric }) => {
  const pctClass =
    metric.variant === "success"
      ? "operator-dashboard__capacity-pct operator-dashboard__capacity-pct--success"
      : "operator-dashboard__capacity-pct operator-dashboard__capacity-pct--warning";

  return (
    <Box className="operator-dashboard__capacity-row">
      <Typography component="p" variant="body2" className="operator-dashboard__capacity-line">
        <span className="operator-dashboard__capacity-line-text">
          {metric.label}: {metric.filled} / {metric.total}
        </span>
      </Typography>
      <Typography component="p" variant="body2" className={pctClass}>
        {metric.percent}%
      </Typography>
    </Box>
  );
};
